import React, { useState, useContext, useEffect, useMemo, useCallback, memo } from 'react';
import MapContext from '../Map/MapContext';
import { useGlobalVariablesContext } from '../../context/GlobalVariablesContext';
import './ControlerLayerBase.css';

const ControlerLayerBase = () => {
    const { config } = useGlobalVariablesContext(); // Obtiene la configuración
    const [selectedBaseLayer, setSelectedBaseLayer] = useState(null); // Estado para la imagen seleccionada
    const { map } = useContext(MapContext);

    const [loadedImages, setLoadedImages] = useState({}); // Rastreo de imágenes cargadas

    // Estado para las capas base cargadas en el mapa
    const [layersBase, setLayersBase] = useState([]);

    // Estado para la capa base visible
    const [visibleBaseLayer, setVisibleBaseLayer] = useState(null);

    useEffect(() => {
        if (!map || !config) return;

        // Obtener las capas base del mapa
        const baseLayers = [];
        map.getLayers().forEach((layer) => {
            if (layer.get('type') === 'base') {
                baseLayers.push(layer);
                if (layer.getVisible()) {
                    setVisibleBaseLayer(layer.get('name'));
                }
            }
        });
        setLayersBase(baseLayers);
    }, [map, config]);

    // Función optimizada para manejar la carga de imágenes
    const handleImageLoad = useCallback((layerName) => {
        setLoadedImages((prevLoadedImages) => ({
            ...prevLoadedImages,
            [layerName]: true,
        }));
    }, []);

    // Función optimizada para alternar capas base
    const handleLayerToggleBase = useCallback((layerName) => {
        if (!map) return;

        map.getLayers().forEach((layer) => {
            if (layer.get('type') === 'base') {
                layer.setVisible(layer.get('name') === layerName);
            }
        });

        // Actualizamos el estado para recordar la capa base seleccionada
        setVisibleBaseLayer(layerName);
        setSelectedBaseLayer(layerName); // Establece la imagen seleccionada
    }, [map]);

    return (
        <div>
            {layersBase.map((layer) => (
                <div className="base-layer-container" key={layer.get('name')}>
                    <div className="layer-img">
                        <img
                            className={visibleBaseLayer === layer.get('name') ? 'selected' : ''}
                            src={layer.get('image')}
                            alt={layer.get('title')}
                            onClick={() => handleLayerToggleBase(layer.get('name'))}
                            onLoad={() => handleImageLoad(layer.get('name'))}
                            style={{
                                cursor: 'pointer',
                                display: loadedImages[layer.get('name')] ? 'block' : 'none',
                            }}
                        />
                        {!loadedImages[layer.get('name')] && <div className="placeholder"></div>}
                    </div>
                    <label title={layer.get('description')} htmlFor={layer.get('name')}>
                        {layer.get('title')}
                    </label>
                </div>
            ))}
        </div>
    );
};

export default memo(ControlerLayerBase);
